<template>
  <main class="pr-3">
    <main
      class="notification-container"
      ref="notificationSideList"
      v-if="filteredNotifications().length"
    >
      <section
        v-for="(group, date) in groupedNotifications"
        :key="date"
        class="mb-3"
        :data-notification-id="currentNotification"
      >
        <section class="flex gap-5 items-center justify-center">
          <div
            class="w-32 bg-gray-400 md:h-px h-0 invisible hidden md:flex md:visible ml-3"
          ></div>
          <p class="font-bold p-2 text-left md:text-center flex-1">
            {{ date }}
          </p>
          <div
            class="w-32 bg-gray-400 md:h-px h-0 invisible hidden md:flex md:visible mr-3"
          ></div>
        </section>

        <section
          v-for="notification in group"
          :key="notification.id"
          class="flex flex-col sm:flex-row gap-2 py-3 p-2 hover:bg-gray-300 cursor-pointer"
          :class="
            currentNotification === notification.id ? 'bg-gray-300' : 'initial'
          "
          @click="setCurrentNotitification(notification, notification.id)"
          :id="notification.id"
        >
          <section
            class="w-8 md:h-8 rounded-full bg-gray-700 text-white text-center relative invisible md:visible h-0"
          >
            <p class="flex items-center w-full h-full justify-center text-xs">
              {{ getInitials(notification.createdBy) }}
            </p>
            <div
              class="h-2 w-2 rounded-full bg-green-500 absolute right-1 top-6"
              v-if="formatStatus(notification.status)"
            ></div>
          </section>

          <section class="flex-1">
            <section class="flex flex-col lg:flex-row gap-2 items-start">
              <p class="font-bold line-clamp-1 md:line-clamp-none">
                {{ notification.title }}
              </p>
              <p
                class="font-thin line-clamp-1 md:line-clamp-none"
                style="font-size: 0.7rem !important"
              >
                {{ formatDate(notification.createdAt) }}
              </p>
            </section>
            <p class="line-clamp-2 lg:line-clamp-1">
              {{ notification.content }}
            </p>
          </section>
        </section>
      </section>
    </main>
    <main v-else>
      <el-empty description="No results"> </el-empty>
    </main>
  </main>
</template>

<script>
import moment from "moment";
import { notifications } from "../../data/notifications.json";

export default {
  name: "NotificationList",
  props: {
    getNotificationToRead: Function,
    currentNotitificationFromRoute: Object,
    searchString: String,
  },

  data() {
    return {
      notifications: notifications,
      currentNotification: null,
      searchInput: null,
    };
  },
  computed: {
    groupedNotifications() {
      const grouped = {};

      this.filteredNotifications().forEach((notification) => {
        const date = this.getGroupingDate(notification.createdAt);
        if (!grouped[date]) {
          grouped[date] = [];
        }
        grouped[date].push(notification);
      });

      return grouped;
    },
  },
  watch: {
    searchString: function (searchString) {
      this.searchInput = searchString;
      this.filteredNotifications();
    },
  },

  created() {
    this.sortNotifications();
    if (this.currentNotitificationFromRoute) {
      this.currentNotification = this.currentNotitificationFromRoute.id;
      this.$nextTick(() => {
        this.scrollToCurrentNotification();
      });
    }
  },

  methods: {
    filteredNotifications() {
      if (!this.searchInput) {
        return this.notifications;
      } else {
        const searchInputLower = this.searchInput.toLowerCase();
        return this.notifications.filter((item) => {
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    scrollToCurrentNotification() {
      if (this.currentNotification) {
        const container = this.$refs.notificationSideList;
        const element = container.querySelector(
          `[data-notification-id="${this.currentNotification}"]`
        );

        if (element) {
          const elementTop = element.offsetTop - container.offsetTop;
          container.scrollTop = elementTop;
        }
      }
    },

    sortNotifications() {
      this.notifications = this.notifications.sort(
        (a, b) => moment(a.createdAt) < moment(b.createdAt)
      );
    },
    getGroupingDate(dateStr) {
      const date = moment(dateStr, "YYYY-MM-DD HH:mm:ss");
      const today = moment().startOf("day");
      const lastWeek = moment().startOf("day").subtract(1, "week");
      const lastMonth = moment().startOf("day").subtract(1, "month");

      if (date.isSameOrAfter(today, "day")) {
        return "Today";
      } else if (date.isSameOrAfter(lastWeek, "day")) {
        return "Last Week";
      } else if (date.isSameOrAfter(lastMonth, "day")) {
        return "Last Month";
      } else {
        return date.format("MMM Do, YYYY");
      }
    },

    getInitials(fullname) {
      const names = fullname.split(" ");
      return names
        .map((name) => name[0])
        .join("")
        .toUpperCase();
    },
    formatDate(dateStr) {
      const date = moment(dateStr, "YYYY-MM-DD HH:mm:ss");
      const formatedDateTime = date.format("ddd DD/MM/YYYY HH:mma");
      const iscurrentDate = date.isSame(new Date(), "day");
      if (iscurrentDate) {
        return `Today ${date.format("DD/MM/YYYY HH:mma")}`;
      } else {
        return formatedDateTime;
      }
    },
    createOverview() {},

    formatStatus(status) {
      return status ? true : false;
    },
    setCurrentNotitification(notification, id) {
      this.getNotificationToRead(notification);
      this.currentNotification = id;
    },
  },
};
</script>
<style>
.notification-container {
  overflow-y: auto;
}
</style>
